import { useRef, useState, useEffect, useCallback } from "react";
import { isValidCoordinate } from "@/constants/map";

export const useCopySelectedPoints = ({ selectedPoints, points }) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    document.execCommand("copy"); //deprecated, но работает на http
    document.body.removeChild(textarea);
  };

  const copy = useCallback(async () => {
    if (!points || selectedPoints.size === 0) return;

    const selected = [...selectedPoints]
      .sort((a, b) => a - b)
      .map((i) => points[i])
      .filter(
        (p) =>
          p &&
          isValidCoordinate(p.lat, -90, 90) &&
          isValidCoordinate(p.lon, -180, 180),
      );

    if (!selected.length) return;

    const text = selected.map(({ lat, lon }) => `${lat}\t${lon}`).join("\n");

    if (!navigator?.clipboard) {
      fallbackCopy(text);
    } else {
      navigator.clipboard.writeText(text);
    }

    setCopied(true);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      timeoutRef.current = null;
    }, 2000);
  }, [points, selectedPoints]);

  // Ctrl / Cmd + C
  useEffect(() => {
    const handler = (e) => {
      const isCopy =
        (e.ctrlKey || e.metaKey) &&
        (e.key.toLowerCase() === "c" || e.key.toLowerCase() === "с");

      if (!isCopy) return;
      if (selectedPoints.size === 0) return;
      if (window.getSelection()?.toString()) return;

      e.preventDefault();
      copy();
    };

    window.addEventListener("keydown", handler, true);
    return () => window.removeEventListener("keydown", handler, true);
  }, [selectedPoints, points, copy]);

  // сброс при изменении выделения
  useEffect(() => {
    setCopied(false);
  }, [selectedPoints]);

  return { copied, copy };
};
